import type { ReactElement } from 'react';
import type { ConstraintIssue } from '../../../domain/scheduling/scheduleMath';

interface IssueListProps {
  issues: readonly ConstraintIssue[];
}

export function IssueList({ issues }: IssueListProps): ReactElement | null {
  if (issues.length === 0) return null;
  return (
    <ul className="fsg-issues" aria-live="polite">
      {issues.map((item, index) => (
        <li
          key={`${item.code}:${index}`}
          className={item.severity === 'ERROR' ? 'fsg-issue fsg-issue-error' : 'fsg-issue fsg-issue-warn'}
        >
          <span className="fsg-issue-tag">{item.severity === 'ERROR' ? 'Blocked' : 'Warning'}</span>
          {item.message}
        </li>
      ))}
    </ul>
  );
}
